import {Injectable} from '@angular/core';
import {AbstractWidgetService} from '../../services/abstract-widget.service';
import { DocumentEditorActionsType, TemplateActionArgs, UiWidget, WProperties } from '@pt/pt-models';
import {WidgetActionsUtils} from '../../utils';
import {
  WidgetPreliminaryRiskAssessmentPropertiesV0
} from './v0/models/widget-preliminary-risk-assessmant-properties-v0';
import {WidgetPreliminaryRiskAssessmentValueV0} from './v0/models/widget-preliminary-risk-assessment-value-v0';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {GetChapterResponse} from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';

@Injectable({
  providedIn: 'root'
})
export class WidgetPreliminaryRiskAssessmentService extends AbstractWidgetService {

  constructor(public store: Store, public translateService: TranslateService) {
    super(store, translateService);
  }

  /**
   * TRIGGER
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  execTrigger(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    if (widget?.version !== null && widget?.version !== undefined) {
      switch (widget.version) {
        case 0:
          return this.execTriggerV0(context, widgets, widget, action, args, queryResponse);
        default:
          this.invalidWidgetVersion(widget);
          return null;
      }
    }
    return null;
  }

  /**
   * INITIALIZATION
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  initialization(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    this.unsupportedInitialization(widget);
    return null;
  }

  private execTriggerV0(context: GetChapterResponse, widgets: UiWidget[], widget: UiWidget, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    switch (action) {
      case DocumentEditorActionsType.ACTIVE_ACTION:
        this.validWidgetAction(widget, action);
        return this.activeAction(widget, widgets, args, queryResponse);

      case DocumentEditorActionsType.DEACTIVATE_ACTION:
        this.validWidgetAction(widget, action);
        return this.disableAction(widget, widgets, args, queryResponse);

      default:
        this.invalidWidgetAction(widget, action);
    }
    return null;
  }

  private disableAction(currentWidget: UiWidget, widgets: UiWidget[], args: TemplateActionArgs, queryResponse?: any) {
    const response: any[] = queryResponse as any[];
    const widget = JSON.parse(JSON.stringify(currentWidget)) as UiWidget;
    const sourceValue: number[] = WidgetActionsUtils.execJsonPath(args?.jsonPath?.source, widgets);
    if (sourceValue?.length > 0 && args?.jsonPath?.expectedValue?.length > 0) {
      const expectedValue = args?.jsonPath?.expectedValue;
      let valid = true;
      sourceValue.forEach((f) => {
        if (!expectedValue?.includes(f)) {
          valid = false;
        }
      });

      let uuid: string = null;
      if (response?.length === 1) {
        uuid = response[0]?.uuid;
      }
      const wProp: WidgetPreliminaryRiskAssessmentPropertiesV0 = widget.properties ? widget.properties as WidgetPreliminaryRiskAssessmentPropertiesV0 : {};
      let uuidDisabled: string[] = wProp?.uuidDisabled ? wProp.uuidDisabled : [];

      if (!uuid) {
        console.warn('Missing Preliminary Risk Assessment Uuid in Trigger deactiveAction');
        return null;
      }

      if (valid) {
        const widgetValue: WidgetPreliminaryRiskAssessmentValueV0[] = widget.value;
        uuidDisabled = uuidDisabled.filter((d) => d !== uuid);
        wProp.uuidDisabled = uuidDisabled;
        widget.value = widgetValue.map(v => v.editable = uuidDisabled.includes(v.uuid));
        return widget;
      }
    }
    return null;
  }

  private activeAction(currentWidget: UiWidget, widgets: UiWidget[], args: TemplateActionArgs, queryResponse?: any) {
    const response: any[] = queryResponse as any[];
    const widget = JSON.parse(JSON.stringify(currentWidget)) as UiWidget;
    const sourceValue: number[] = WidgetActionsUtils.execJsonPath(args?.jsonPath?.source, widgets);
    if (sourceValue?.length > 0 && args?.jsonPath?.expectedValue?.length > 0) {
      const expectedValue = args?.jsonPath?.expectedValue;
      let valid = true;
      sourceValue.forEach((f) => {
        if (!expectedValue?.includes(f)) {
          valid = false;
        }
      });

      let uuid: string = null;
      if (response?.length === 1) {
        uuid = response[0]?.uuid;
      }

      const wValue: WidgetPreliminaryRiskAssessmentValueV0[] = widget.value || [];
      const uuidDisabled: string[] = wValue.filter((v) => !v.editable).map((v) => v.uuid); // wProp?.uuidDisabled ? wProp.uuidDisabled : [];

      if (!uuid) {
        console.warn('Missing Preliminary Risk Assessment Uuid in Trigger activeAction');
        return null;
      }

      if (valid) {
        let widgetValue: WidgetPreliminaryRiskAssessmentValueV0[] = widget.value;
        if (!uuidDisabled.find(u => u === uuid)) {
          uuidDisabled.push(uuid);
        }
        widgetValue = widgetValue.filter((w) => w.uuid !== uuid);
        widgetValue.push({uuid, selected: true, editable: !uuidDisabled.includes(uuid)});
        widget.value = widgetValue;
        return widget;
      }
    }
    return null;
  }

}

